import { sanitizeEditorInput } from "../../SafeHtml";

type ClipboardClass = new (...args: any[]) => {
  convert(html?: unknown): unknown;
};

/**
 * Quill 1.x parses HTML (initial value, controlled value, paste,
 * dangerouslyPasteHTML) by setting innerHTML on a container attached to the
 * document, so an inline handler in stored HTML (`<img onerror>`) fires
 * before Quill drops the attribute. Sanitizes before it gets there.
 */
export const withSafeConvert = <T extends ClipboardClass>(Base: T): T =>
  class SafeClipboard extends Base {
    convert(html?: unknown) {
      return super.convert(
        typeof html === "string" ? sanitizeEditorInput(html) : html
      );
    }
  };
